export const HLS_STREAM_URL = "https://dmr6tx0csl9hs.cloudfront.net/biharkrishiradio.m3u8";
export const AAC_STREAM_URL = "https://streamasiacdn.atc-labs.com/biharkrishiradio.aac";
export const DEFAULT_VOLUME = 0.7;
